import React from "react";
import { SelectValue } from "antd/es/select";
import { SelectProps } from "antd";

import { Select as MSelect, Label, Text } from "./styles/select";
import {
  FieldError,
  RequiredMark,
  ScreenReaderOnly,
} from "src/components/Form/styles/form";
import { Search01Icon } from "@hugeicons/core-free-icons";
import HugeIcon from "src/components/HugeIcon";
import { colors } from "src/theme/colors";

const { Option, OptGroup } = MSelect;

interface Props extends SelectProps<any> {
  name: string;
  id?: string;
  label?: string;
  onSelectionChange?: (value: SelectValue, name: string) => void;
  group?: boolean;
  items?: any[];
  defaultValue?: any;
  error?: any;
  isNew?: boolean;
  /** Marks the label, so a field that must be filled in says so up front. */
  required?: boolean;
}

const Select = ({
  label,
  onSelectionChange,
  group,
  items,
  name,
  error,
  defaultValue,
  id,
  isNew,
  required,
  ...rest
}: Props) => {

  return (
    <>
      {/* The label stays ink and the complaint goes under the field, as it
          does on every input in the product. It used to sit at the far right
          of the label row, so the error read as a second caption on the
          field and the name of the field turned red with it. */}
      <Label htmlFor={id}>
        <Text>
          {label}
          {required && (
            <>
              <RequiredMark aria-hidden="true">*</RequiredMark>
              <ScreenReaderOnly> required</ScreenReaderOnly>
            </>
          )}
        </Text>
      </Label>
      {isNew && (
        <div
          style={{
            position: "absolute",
            zIndex: 9,
            marginLeft: "17px",
            marginTop: "6px",
          }}
        >
          <HugeIcon icon={Search01Icon} style={{ fontSize: "32px", color: colors.primary[300] }} />
        </div>
      )}
      <MSelect
        listHeight={250}
        virtual={false}
        error={error}
        aria-required={required || undefined}
        id={id || name}
        style={{ width: "100%" }}
        defaultValue={defaultValue}
        onChange={(value) => onSelectionChange(value, name || id)}
        
        {...rest}
      >
        <>
          {isNew &&
            items?.map(({ name, value }, i) => (
              <Option key={i} value={value}>
                {name}
              </Option>
            ))}
        </>
        {group
          ? items?.map(({ options, label }, i) => (
              <OptGroup key={i} label={label}>
                {options?.map(({ label, value }) => (
                  <Option key={value} value={value}>
                    {label}
                  </Option>
                ))}
              </OptGroup>
            ))
          : items?.map(({ label, value }, i) => (
              <Option key={i} value={value}>
                {label}
              </Option>
            ))}
      </MSelect>
      {error && <FieldError role="alert">{error}</FieldError>}
    </>
  );
};

export default Select;
